export default __webpack_public_path__ + "static/media/Poppins-ExtraLightItalic.dbdfd398.ttf";